// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"301":"02cd62f0","525":"f91ebe7b","779":"c9236da8","959":"d49f675e"}[chunkId] + ".chunk.js";
};